import 'rxjs/add/operator/map';
import fetchJson$ from '../../common/fetch/as-json-stream';

export interface SuggestedPeople {
	recommendedUsers: [
		{
			id: string;
			name: string;
			avatarUrl: string;
			title?: string | null;
			nickname: string;
		},
	];
}

const SUGGESTED_PEOPLE_URL = '/gateway/api/v1/recommendations';

export const getSuggestedPeople$ = (cloudId: string, userId: string, projectId: number) =>
	fetchJson$<SuggestedPeople>(SUGGESTED_PEOPLE_URL, {
		credentials: 'include',
		method: 'POST',
		body: JSON.stringify({
			context: {
				contextType: 'Mentions, Assignee, Generic, <BYO>',
				principalId: userId,
				siteId: cloudId,
				productKey: 'jira',
				containerId: projectId,
			},
			searchQuery: { queryString: '' },
			maxNumberOfResults: 10,
			filter: '(NOT not_mentionable:true) AND (account_status:active)',
		}),
	}).map((response) => {
		return response.recommendedUsers
			.filter((account) => account.id !== userId)
			.map((account) => ({
				id: account.id,
				name: account.name,
				avatarUrl: account.avatarUrl,
			}));
	});
